<template>
  <div style="max-width: 100%;margin-top: 80px;display: flex; flex-direction: column; align-items: center;">
    <div style="width: 92%;">
      <div style="display: flex; width: 100%; ">
        <div style="flex: 1;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #43454F;
          line-height: 38px;text-align: left;font-style: normal;text-transform: none;">EVM兼容链条</a>
        </div>
        <div style="flex: 1; text-align: right;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #969799;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">></a>
        </div>
      </div>
   </div>
   <hr style="width: 100%;border-radius: 0px 0px 0px 0px;border: 1px solid #F3F6FB;">
   <div style="width: 92%;">
      <div style="display: flex; width: 100%; ">
        <div style="flex: 1;">
          <div style="display: flex;align-items: center;">
            <van-image style="width: 24px;height: 24px;" src="img/walletMenuEvm/walletMenuEvm_bsc.svg"></van-image>
            <div style="margin-left: 9px;">
              <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #43454F;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">BSC</a>
            </div>
          </div>
        </div>
        <div style="flex: 1; text-align: right;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #969799;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">></a>
        </div>
      </div>
    </div>
    <hr style="width: 100%;border-radius: 0px 0px 0px 0px;border: 1px solid #F3F6FB;">
    <div style="width: 92%;">
      <div style="display: flex; width: 100%; ">
        <div style="flex: 1;">
          <div style="display: flex;align-items: center;">
            <van-image style="width: 24px;height: 24px;" src="img/walletMenuEvm/walletMenuEvm_heco.svg"></van-image>
            <div style="margin-left: 9px;">
              <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #43454F;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">HECO</a>
            </div>
          </div>
        </div>
        <div style="flex: 1; text-align: right;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #969799;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">></a>
        </div>
      </div>
    </div>
    <hr style="width: 100%;border-radius: 0px 0px 0px 0px;border: 1px solid #F3F6FB;">
    <div style="width: 92%;">
      <div style="display: flex; width: 100%; ">
        <div style="flex: 1;">
          <div style="display: flex;align-items: center;">
            <van-image style="width: 24px;height: 24px;" src="img/walletMenuEvm/walletMenuEvm_ftm.svg"></van-image>
            <div style="margin-left: 9px;">
              <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #43454F;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">FTM</a>
            </div>
          </div>
        </div>
        <div style="flex: 1; text-align: right;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #969799;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">></a>
        </div>
      </div>
    </div>
    <hr style="width: 100%;border-radius: 0px 0px 0px 0px;border: 1px solid #F3F6FB;">
    <div style="width: 92%;">
      <div style="display: flex; width: 100%; ">
        <div style="flex: 1;">
          <div style="display: flex;align-items: center;">
            <van-image style="width: 24px;height: 24px;" src="img/walletMenuEvm/walletMenuEvm_polygon.svg"></van-image>
            <div style="margin-left: 9px;">
              <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #43454F;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">Polygon</a>
            </div>
          </div>
        </div>
        <div style="flex: 1; text-align: right;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #969799;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">></a>
        </div>
      </div>
    </div>
    <hr style="width: 100%;border-radius: 0px 0px 0px 0px;border: 1px solid #F3F6FB;">
    <div style="width: 92%;">
      <div style="display: flex; width: 100%; ">
        <div style="flex: 1;">
          <div style="display: flex;align-items: center;">
            <van-image style="width: 24px;height: 24px;" src="img/walletMenuEvm/walletMenuEvm_gnosis.svg"></van-image>
            <div style="margin-left: 9px;">
              <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #43454F;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">Gnosis</a>
            </div>
          </div>
        </div>
        <div style="flex: 1; text-align: right;">
          <a style="font-family: PingFang HK, PingFang HK;font-weight: 500;font-size: 16px;color: #969799;
          line-height: 38px;text-align: center;font-style: normal;text-transform: none;">></a>
        </div>
      </div>
    </div>
    <hr style="width: 100%;border-radius: 0px 0px 0px 0px;border: 1px solid #F3F6FB;">
  </div>
</template>
<script>
export default {
  name: "walletMenuEvmIndex",
}
</script>

<style>

</style>